angular.module('eStories.compnt.audiobookReview', [

    /*Audiobook Review Component*/
    'eStories.review.model',

])

    .component('audiobookReview', {

        bindings: {
            review: '='
        },

        transclude: true,

        controller: ['$filter', function ($filter) {


            this.getStringDate = function (dateData) {
                return getStringDate(dateData);
            };

            this.getAvatarBackgroundStyle = function (url) {
                return getCoverStyleBackground($filter("imageByWidth")(url, 120));
            }
        }],

        templateUrl: '/components/templates/rateReview/audiobookReview.tmpl.html'
    });
